// extracted by mini-css-extract-plugin
module.exports = {"container":"SeeDeeperSvg_container___SolX","wider":"SeeDeeperSvg_wider__pmQfd"};